// maintains a state so that we won't be showing to many pop ups to annoy our users

export default {
  _lastPopTs: null,

  set() {
    this._lastPopTs = Math.floor(Date.now() / 1000);
  },

  isLocked() {
    if (!this._lastPopTs) { return false; }
    if (this._lastPopTs + 86400 < Math.floor(Date.now() / 1000)) { return false; }
    return true;
  },
};
